import { asyncRoutes, constantRoutes } from "../../routes/data";

const state = {
  routes: [], // 所有的路由信息 constantRoutes + asyncRoutes
  renderRoutes: [], // 参与渲染的路由信息(顶部 + 侧边) asyncRoutes
  filterRouteList: [], // 权限处理后的路由  layout菜单
  moduleRoutes: {}, // 子模块路由信息
  rootPath: "", // 根路由信息
  routeType: null, // 当前所在路由的类型: module/child/null
  sideRouteList: [],
  deploymentAddress:
    import.meta.env.VITE_ENV === "zhongyi" ? "zhongyi" : "test", // 部署地址   根据不同的部署地址，添加视频流任务引入不同的config   zhongyi
};

//同步
const mutations = {
  SET_ROUTES: (state, routes) => {
    state.renderRoutes = constantRoutes.concat(routes);
    state.routes = constantRoutes.concat(routes);
  },
  SET_MODULE_ROUTES: (state, routes) => {
    state.moduleRoutes[routes.path] = routes;
  },
  SET_ROOT_PATH: (state, root) => {
    state.rootPath = root;
  },
  SET_ROUTE_TYPE: (state, type) => {
    state.routeType = type;
  },

  SET_RESET_ROUTES(state) {
    state.renderRoutes = [];
  },

  SET_FILTER_ROUTES(state, routes = []) {
    state.filterRouteList = routes;
  },
  SET_SIDE_LIST: (state, value) => {
    state.sideRouteList = value;
  },
};

//异步
const actions = {
  clearRoutes({ commit }, value) {
    commit("SET_RESET_ROUTES", value);
  },
  // 生成路由
  generateRoutes({ commit }) {
    return new Promise((resolve) => {
      let accessedRoutes = [asyncRoutes];

      accessedRoutes = accessedRoutes.concat([
        { path: "/:pathMatch(.*)*", redirect: "/404", hidden: true },
      ]);
      commit("SET_ROUTES", accessedRoutes);
      resolve(accessedRoutes);
    });
  },
  //  防止后续需要针对子模块路由做单独处理
  generateModuleRoutes({ commit }, routes) {
    return new Promise((resolve) => {
      commit("SET_MODULE_ROUTES", routes);
      resolve(routes);
    });
  },
  updateRootPath({ commit }, path) {
    return new Promise((resolve) => {
      commit("SET_ROOT_PATH", path);
      resolve(path);
    });
  },
  updateRouteType({ commit }, type) {
    return new Promise((resolve) => {
      commit("SET_ROUTE_TYPE", type);
      resolve(type);
    });
  },

  updateFilterRoutes({ commit }, value) {
    return new Promise((resolve) => {
      commit("SET_FILTER_ROUTES", value);
      resolve(value);
    });
  },

  updateSideList({ commit }, value) {
    return new Promise((resolve) => {
      commit("SET_SIDE_LIST", value);
      resolve(value);
    });
  },
};

export default {
  namespaced: true, // 解决不同模块命名冲突的问题
  state,
  mutations,
  actions,
};
